import React from "react";
import './IntegrationsPageStyle.css';

export default class IntegrationsPageComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    render(){
        return(
            <div>
                Integrations Page
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/Main/IntegrationsPage/IntegrationsPage.js